// extracted by mini-css-extract-plugin
export default {"wrapper":"GkPPO","avatar":"D1DBQ","border":"HnIRv"};